/* eslint-disable @typescript-eslint/no-explicit-any */
import { ErrorBoundary } from 'components/Errors/ErrorBoundary';
import LoadingScreen from 'components/LoadingScreen';
import PageLayout from 'components/PageLayout';
import ActiveFiltersBar from 'components/SearchAndFilters/SelectedFiltersBar';
import { useAtomValue, useSetAtom } from 'jotai';
import React, { Suspense } from 'react';
import { ToastContainer } from 'react-toastify';
import { CardTitle, Col, Row } from 'reactstrap';

import BulkActions from './BulkActions';
import Filters from './Filters';
import { useFilterConfig } from './Filters.config';
import MembersDataGrid from './MembersDataGrid';
import {
  filterValuesAtom,
  membersDataAtom,
  useOnFilterChangeResetAtoms,
} from './state';

const SelectedFilters: React.FC<{ filtersConfig: any }> = ({
  filtersConfig,
}) => {
  const setFilterValues = useSetAtom(filterValuesAtom);
  const resetOnFilterChangeAtoms = useOnFilterChangeResetAtoms();

  return (
    <Suspense fallback={<></>}>
      <ActiveFiltersBar
        filtersConfig={filtersConfig}
        onFiltersReset={() => {
          setFilterValues({ ...filtersConfig.getActiveFilterValues() });
          resetOnFilterChangeAtoms();
        }}
      />
    </Suspense>
  );
};

const ListingCount: React.FC = () => {
  const listingData = useAtomValue(membersDataAtom);
  return <>{listingData?.loading ? '...' : listingData.count}</>;
};

/**
 * Main component for the Members
 * Displays a list of members with filtering and search options
 */
const Members: React.FC = () => {
  const filtersConfig = useFilterConfig();
  return (
    <PageLayout
      id="company-members"
      heading={
        <Row>
          <Col md="auto" sm="12">
            <CardTitle>
              <h4>
                Members Management
                <label id="counts" className="label btn">
                  <Suspense fallback={<>...</>}>
                    <ListingCount />
                  </Suspense>
                </label>
              </h4>
            </CardTitle>
          </Col>
        </Row>
      }
      subheading={<span>List of Members.</span>}
      description={<p>Manage members and their subscriptions.</p>}
      filteringOptions={<Filters filtersConfig={filtersConfig} />}
    >
      <Suspense fallback={<LoadingScreen />}>
        <div className="container-fluid p-0">
          <div className="container-fluid">
            <div className="row">
              {/* Expanding Column */}
              <div className="col p-1">
                <SelectedFilters filtersConfig={filtersConfig} />
              </div>

              {/* Fixed Column with Right-Aligned Content */}

              <div className="col-auto p-1 text-right align-baseline">
                <Suspense fallback={<>...</>}>
                  <BulkActions />
                </Suspense>
              </div>
            </div>
          </div>
          <Suspense fallback={<LoadingScreen />}>
            <MembersDataGrid />
          </Suspense>
        </div>
      </Suspense>
    </PageLayout>
  );
};

const MembersListing: React.FC = () => {
  return (
    <Suspense fallback={<LoadingScreen />}>
      <div className="content">
        <ErrorBoundary>
          <Members />
        </ErrorBoundary>
      </div>
      <ToastContainer />
    </Suspense>
  );
};

export default MembersListing;
